import type { SettingsValues } from './settings-value';

const SUBSCRIBED_DATASETS_KEY = 'subscribed_datasets';

/**
 * Number of selected datasets ("pipelines") for the summary, or `null` when the
 * schema has no `subscribed_datasets` section — so we render a neutral label
 * instead of a misleading "0 pipelines enabled".
 */
export const countSubscribedDatasets = (
  values: SettingsValues
): number | null => {
  const value = values[SUBSCRIBED_DATASETS_KEY];
  return Array.isArray(value) ? value.length : null;
};

export const summarizeDataBuilderSettings = (
  values: SettingsValues
): string => {
  const count = countSubscribedDatasets(values);
  if (count === null) {
    return 'Data Builder configuration';
  }
  if (count === 0) {
    return 'No pipelines enabled';
  }
  return `${count} pipeline${count === 1 ? '' : 's'} enabled`;
};
